// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"882":"storage","933":"monitoring","943":"usecenter","970":"mgtcenter"}[chunkId] || chunkId) + "." + {"189":"8019fc44","274":"93cb9807","625":"13efe7a5","688":"2b89c293","784":"ccaa46d3","882":"ba1ae661","933":"1c88fc5e","943":"fe5afed5","970":"5756ce6a"}[chunkId] + ".js";
};